import React from "react";

import { UserInfoQuestions } from "consts";
import { useStarQuestion } from "screens/question/hooks";

import { Container, Star } from "./styled";

export const StarQuestion = ({ question, section }) => {
  const { selectOption, selectedIndex } = useStarQuestion(question);

  const isUserInfoScreen = section.questions.some(
    q => UserInfoQuestions[q.app_screen_type],
  );

  return (
    <Container $compact={!isUserInfoScreen}>
      {question.options.map((option, index) => {
        const starIsColored = index <= selectedIndex;
        return (
          <Star
            name="star"
            key={option.id}
            onPress={() => selectOption(option)}
            color={starIsColored ? "#ffd000" : "#D3D3D3"}
          />
        );
      })}
    </Container>
  );
};
